// extracted by mini-css-extract-plugin
export var image = "BeerOfMonth-module--image--fTIUZ";
export var root = "BeerOfMonth-module--root--73Rbb";
export var verticalTextBig = "BeerOfMonth-module--verticalTextBig--FXhCb";